import type { FC } from 'react';
import { getFormattedStatus } from '@root/helpers';
import clsx from 'clsx';

const statusColorMap: Record<string, string> = {
  REVIEW: 'fill-red-500',
  FIRM_ORDER: 'fill-green-500',
  FINAL: 'fill-primary-500',
  PUBLISHED: 'fill-primary-500',
  ARCHIVED: 'fill-info-300',
  DRAFT: 'fill-yellow-500',
};

/** Compact status indicator for palette rows (StatusBadge is too heavy at this density). */
export const StatusDot: FC<{ status: string }> = ({ status }) => (
  <span className="text-muted-foreground inline-flex w-24 shrink-0 items-center gap-1.5 text-xs">
    <svg className={clsx('h-1.5 w-1.5', statusColorMap[status] ?? 'fill-info-300')} viewBox="0 0 6 6" aria-hidden>
      <circle cx={3} cy={3} r={3} />
    </svg>
    {getFormattedStatus(status)}
  </span>
);
